<template>
  <v-app>
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
.app,
* {
  font-family: "Prompt", sans-serif !important;
}

v-application {
  font-family: 'Prompt', sans-serif !important;
  font-size: 14px !important;
}

.custom-input{
  display: block;
  width: 100%;
  height: calc(1.5em + .75rem + 2px);
  padding: .375rem .75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: .25rem;
  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}

.v-text-field--outlined legend {
  width: 0;
}

.outline-none {
  outline: none;
}
</style>
